export const COLOR_BLACK = '#000000'
export const COLOR_BLUE = '#2d85f3'
export const COLOR_DIVINE = '#808080'
export const COLOR_GRAY = '#b2b2b2'
export const COLOR_WHITE = '#fff'
export const COLOR_YELLOW = '#F1BB00'
